import * as React from "react";
import styled from "styled-components";
import Badge from "components/bootstrap/Badge";
const StyledBadge = styled(Badge)`
  vertical-align: middle;
  margin-top: -2%;
`;
const PreviewBadge = () => /* @__PURE__ */ React.createElement(StyledBadge, { bsStyle: "info" }, "Preview");
export default PreviewBadge;
